import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import {
	BrowserRouter as Router,
	Route,
	Switch,
	useHistory,
	useLocation,
} from 'react-router-dom';
// import { Home, SignIn, SignUp, VideoCall } from './pages';
import * as ROUTES from './constants/routes';
import {
	Home,
	SignIn,
	SignUp,
	VideoCall,
	PasswordReset,
	Clients,
	Calendar,
	ThreeDHomes,
	Siteplan,
	Doc,
	DocClient,
	Profile,
	FileExplorer,
	Finance,
	BoxMatrix,
	BookAppointment,
} from './pages';
import { useAuthListener } from './hooks/index';
import { AuthProvider } from './Auth';

import PrivateRoute from './helpers/PrivateRoute';

// Redux

import { Provider } from 'react-redux';
import store from './store';
import { FirebaseContext } from './context/firebase';

export default function App() {
	const { user } = useAuthListener();
	const [userType, setUserType] = useState('');
	const { firebase } = useContext(FirebaseContext);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;
				var capFirst;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE: ' + currentUserType);
					});
				setUserType(currentUserType);
			}
		});
	}, [userType]);

	//toggle on off the console log
	window.console.log =
		window.console.debug =
		window.console.info =
		window.console.error =
			function () {
				return false;
			};

	return (
		<Provider store={store}>
			<AuthProvider>
				<Router>
					<PrivateRoute exact path={ROUTES.HOME} component={Home} />
					<Route exact path={ROUTES.SIGN_IN} component={SignIn} />
					<Route exact path={ROUTES.SIGN_UP} component={SignUp} />
					<Route exact path={ROUTES.RESET_PASSWORD} component={PasswordReset} />
					<PrivateRoute exact path={ROUTES.VIDEO_CALL} component={VideoCall} />
					<PrivateRoute
						exact
						path={ROUTES.THREE_D_HOMES}
						component={ThreeDHomes}
					/>
					{/* <PrivateRoute
						exact
						path={ROUTES.DOC_CLIENT}
						component={DocClient}
					/>
					<PrivateRoute
						exact
						path={ROUTES.BOX_MATRIX}
						component={BoxMatrix}
					/> */}
					<PrivateRoute exact path={ROUTES.SITEPLAN} component={Siteplan} />

					{(userType === 'admin' || userType === 'superadmin') && (
						<>
							{/* <PrivateRoute exact path={ROUTES.PROFILE} component={Profile} /> */}

							{/* <PrivateRoute
								exact
								path={ROUTES.MY_CLIENTS}
								component={Clients}
							/> */}
							<PrivateRoute exact path={ROUTES.CALENDAR} component={Calendar} />
							{/* <PrivateRoute exact path={ROUTES.DOC} component={Doc} /> */}
							{/* <Route exact path={ROUTES.DOCUMENT} component={Document} /> */}
							{/* <PrivateRoute
								exact
								path={ROUTES.FILE_EXPLORER}
								component={FileExplorer}
							/> */}
							{/* <PrivateRoute exact path={ROUTES.FINANCE} component={Finance} /> */}
						</>
					)}
					{userType !== 'admin' && userType !== 'superadmin' && (
						<>
							{/* <PrivateRoute
								exact
								path={ROUTES.BOOK_APPOINTMENT}
								component={BookAppointment}
							/> */}
						</>
					)}
				</Router>
			</AuthProvider>
		</Provider>
	);
}
